import Axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../../config";
import Control from "../../common/Control";
import Loader from "../../common/Loader";
import PasswordControl from "../../common/PasswordControl";
import Page from "../../common/layout/Page";

const RenewPassword = (props) => {
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [errors, setErrors] = useState({});
  const [canSave, setCanSave] = useState(false);
  const [passwordsEqual, setPasswordsEqual] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMissingParam, setIsMissionParam] = useState(false);
  const [tokenValid, setTokenValid] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!props.match.params.token) {
      setIsMissionParam(true);
    } else {
      checkActivationToken();
    }
  }, []);

  function checkActivationToken() {
    setIsLoading(true);
    Axios.post(API_URL + "tokens/renew-password", {
      token: props.match.params.token,
    })
      .then((res) => {
        setTokenValid(true);
        setErrors({});
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          setErrors(err.response.data);
        }
      })
      .then(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    setErrors({});
    var errs = {};
    if (password != passwordConfirm || password.length == 0) {
      errs.passwordConfirm = "Doit-être identique au premier";
    }

    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      setPasswordsEqual(true);
    } else {
      setPasswordsEqual(false);
    }
    setErrors(errs);
  }, [password, passwordConfirm]);

  function save() {
    if (canSave && passwordsEqual) {
      //save
      setIsLoading(true);
      Axios.post(API_URL + "customers/reset-password", {
        password: password,
        token: props.match.params.token,
      })
        .then((res) => {
          setIsSuccess(true);
          setErrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            setErrors(err.response.data);
          }
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }

  return (
    <Page errors={errors} back="/">
      <div className="row">
        <div className="col-12 col-md-8 col-lg-6 m-auto">
          <div
            style={{
              background: "#FFFFFF",
              borderRadius: 20,
              padding: "40px 36px",
              boxShadow: "0 4px 24px rgba(15, 23, 42, 0.06)",
              border: "1px solid #EEF0F4",
            }}
          >
            <div className="d-center flex-column text-center">
              <img
                src="/images/logo-small.svg"
                className="mb-3 mx-auto"
                style={{ height: 48 }}
              />
              <h2
                style={{
                  color: "#0F172A",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 8,
                }}
              >
                Modifier mon mot de passe
              </h2>

              {isLoading ? (
                <Loader text="Vérification en cours" />
              ) : isMissingParam ? (
                <p className="mb-0 text-danger">Ce lien est incorrect.</p>
              ) : !tokenValid ? (
                <p className="mb-0 text-danger text-center" role="alert">
                  Ce lien n'est plus valide. Demandez-en un nouveau avec « Mot
                  de passe oublié » sur la page de connexion.
                </p>
              ) : isSuccess ? (
                <>
                  <i className="fa fa-check fa-4x text-success animated zoomIn" />
                  <p className="text-success  font-weight-bold mt-3 mb-4 font-weight-bold animated fadeIn">
                    Votre mot de passe a bien été modifié.
                  </p>
                  <Link to="/" className="btn btn-success animated fadeIn">
                    Se connecter
                  </Link>
                </>
              ) : (
                <form
                  className="w-100"
                  onSubmit={(e) => {
                    e.preventDefault();
                    save();
                  }}
                >
                  <p style={{ color: "#64748B" }} className="text-center mb-4">
                    Veuillez saisir votre nouveau mot de passe.
                  </p>
                  <div
                    style={{
                      background: "#F1F2FE",
                    }}
                    className="p-3 rounded text-left w-100"
                  >
                    <Control
                      className=""
                      label="Nouveau mot de passe"
                      type="password"
                      name="password"
                      autocomplete="off"
                      value={password}
                      change={(e) => setPassword(e.target.value)}
                      error={errors}
                      isValid={!errors.password && password != "" && canSave}
                    />
                    <PasswordControl
                      style={{}}
                      password={password}
                      minLength={6}
                      minUppercase={1}
                      minLowercase={3}
                      minNumber={1}
                      setCanSave={setCanSave}
                    />
                    <Control
                      label="Confirmez votre mot de passe"
                      type="password"
                      name="passwordConfirm"
                      autocomplete="off"
                      value={passwordConfirm}
                      change={(e) => setPasswordConfirm(e.target.value)}
                      error={errors}
                      isValid={!errors.passwordConfirm && passwordConfirm != ""}
                    />
                    {passwordConfirm.length > 0 && passwordsEqual && (
                      <div
                        className="d-flex align-items-center animated fadeIn faster"
                        style={{ color: "#16A34A", fontSize: 14 }}
                      >
                        <i className="fa fa-check-circle mr-2" />
                        <span>Les mots de passe correspondent.</span>
                      </div>
                    )}
                    <span className="text-danger">{errors.other}</span>
                    <button
                      className="btn btn-block d-flex align-items-center justify-content-center mt-3"
                      type="submit"
                      disabled={!(canSave && passwordsEqual)}
                      style={{
                        background:
                          canSave && passwordsEqual ? "#3e75ff" : "#C7CBE0",
                        color: "#FFFFFF",
                        borderRadius: 12,
                        padding: "14px 16px",
                        fontWeight: 600,
                        fontSize: 16,
                        border: "none",
                        cursor:
                          canSave && passwordsEqual ? "pointer" : "not-allowed",
                      }}
                    >
                      <i className="fa fa-shield-alt mr-2" />
                      Mettre à jour mon mot de passe
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default RenewPassword;
